import PipedriveIntegration from './PipedriveIntegration';
export default PipedriveIntegration;
